import { getToken, getRefreshToken, setTokens, logout } from '../auth';
import router from '../router';

let refreshing: Promise<boolean> | null = null;

async function tryRefresh(): Promise<boolean> {
  const refreshToken = getRefreshToken();
  if (!refreshToken) return false;

  try {
    const res = await fetch('/api/refresh', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken }),
    });

    if (!res.ok) return false;

    const { token, refreshToken: newRefreshToken } = await res.json();
    setTokens(token, newRefreshToken);
    return true;
  } catch {
    return false;
  }
}

export async function apiFetch(path: string, options: RequestInit = {}): Promise<Response> {
  const makeRequest = () => {
    const token = getToken();
    return fetch(path, {
      ...options,
      headers: {
        ...(options.headers || {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
  };

  let res = await makeRequest();

  if (res.status === 401) {
    // Deduplicate concurrent refresh attempts
    if (!refreshing) {
      refreshing = tryRefresh().finally(() => { refreshing = null; });
    }
    const refreshed = await refreshing;

    if (refreshed) {
      // Retry original request with the new token
      res = await makeRequest();
    }

    if (res.status === 401) {
      await logout();
      router.replace('/login');
      throw new Error('Session expired. Please log in again.');
    }
  }

  return res;
}
